<template>
  <div class="phone-info">
    <div class="text">
      <div class="text__title">
        <div class="text__title-name">
          <p>A<span>N</span><span>N</span>A</p>
        </div>
        <div class="text__title-surname">
          <h2>WALENTYNOWICZ</h2>
          <div class="text__title-surname-bottomline"></div>
        </div>
      </div>
    </div>
    <div class="icon">
      <Icon class="icon__img" />
      <p class="icon__text">Obróc ekran,<br> aby móc poprawnie korzystać z serwisu.</p>
    </div>
  </div>
</template>

<script>
import Icon from "./partials/phone_icon.svg";

export default {
  name: "PhoneInfo",
  components: {
    Icon
  }
};
</script>

<style lang="scss" scoped>
.phone-info {
  background: url("../../assets/mobile_background.jpg");
  background-position: center;
  background-position-x: 90%;
  background-size: cover;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media (max-width: 340px) {
    width: 103%;
    height: 105%;
  }

  .icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30%;
    width: 40rem;
    &__img {
      width: 12rem;
      fill: #f5edea;
    }
    &__text{
        padding-top: 2rem;
        font-size: 2rem;
        font-weight: 500;
        font-family: "Poppins", sans-serif;
        color: #f5edea;
        text-align: center;
    }
  }
}

.text {
  width: 41.1rem;
  text-shadow: 2px 2px 8px #000;
  color: #f5edea;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -150%);
  left: 50%;
  opacity: 1;



  &__title {
    font-family: "Oswald", sans-serif;
    display: flex;
    flex-direction: column;
    position: relative;
    font-weight: bold;

    p {
      position: relative;
      font-family: "Open Sans Condensed", sans-serif;
      font-size: 10rem;
      font-weight: bold;
      /* letter-spacing: 5.97rem; */
      display: block;
      line-height: 8rem;
      z-index: -1;
      border-bottom: 0.5rem solid #f5edea;
      margin: 0;
      padding: 0;
      span:first-child {
        margin: 0 5.97rem;
      }
      span:nth-child(2) {
        margin-right: 5.97rem;
      }
    }

    h2 {
      font-size: 5.85rem;
      letter-spacing: 0.15rem;
      font-weight: bold;
      border-bottom: 0.4rem solid #f05a42;
      padding-bottom: 0.7rem;
    }
  }
}
</style>
